<div *ngIf="banner"
  class="block w-full mx-auto position-relative relative"
  [ngStyle]="{
    'background-color': banner.backgroundColor,
    color: banner.textColor,
    padding: linePadding
  }"
  [class.px-4]="true"
  [class.py-12]="true"
>
  <div class="max-w-6xl mx-auto">
  <div>
    <vsf-title-box
        [titleInfo]="titleInfo"
        [forComponent]="true">
    </vsf-title-box>
  </div>

  <ng-container *ngIf="!isMobile">
    <div class="mt-12 grid gap-6"
        [ngClass]="[
          'grid-cols-1',
          itemsPerSlide === 2 ? 'md:grid-cols-2'
          : itemsPerSlide === 3 ? 'md:grid-cols-3'
          : 'md:grid-cols-4']">
      <div *ngFor="let c of displayedItems; let i = index; trackBy: trackByIdx"
        class="flex flex-col">
        <img *ngIf="c.asset?.type === 'IMAGE'"
            [src]="c.asset | assetPreview:'large':'webp'"
            [alt]="c.title"
            [ngClass]="getShapeClasses() + ' ' + roundedClass +' w-full object-cover'"
        />
        <div *ngIf="c.asset?.type === 'VIDEO' && c.asset?.mimeType === 'video/vimeo'"
            class="relative overflow-hidden bg-black {{ getShapeClasses() }}"
            #videoBox>
          <vsf-vimeo-player *ngIf="sizes[i]?.w && sizes[i]?.h"
            [width]="sizes[i]?.w || 0"
            [height]="sizes[i]?.h || 0"
            [fullSection]="true"
            [withMouseHover]="true"
            [source]="c.asset?.customFields?.videoUrl || c.asset?.source"
            [previewImageUrl]="c.asset?.imageUrl || c.asset?.preview"
            [previewAltText]="c.asset?.customFields?.altText ? c.asset?.customFields?.altText : 'Marketing Banner Video'">
          </vsf-vimeo-player>
        </div>
        <h3
          class="mt-4 text-lg font-semibold"
          [ngStyle]="{
            'text-align': banner.textAlignment ?? 'center'
          }"
          [innerHTML]="c.title | safeHtml"
        ></h3>
        <span
          class="text-base mt-1 line-clamp-4"
          [attr.title]="c.text"
          [ngStyle]="{
            'font-size.px': banner.textFontSize ?? 16,
            'text-align': banner.textAlignment ?? 'center'
          }"
          [innerHTML]="c.text | safeHtml">
        </span>
      </div>
    </div>
  </ng-container>
  <!-- ===== Mobile Tiles ===== -->
  <ng-container *ngIf="isMobile && banner.mobileStyle === 'tiles'">
    <ul role="list"
      class="mt-10 grid gap-6"
      [ngClass]="[ 'grid-cols-1 sm:grid-cols-2' ]"
    >
      <li *ngFor="let c of banner.basicCards; trackBy: trackByIdx">
        <img *ngIf="c.asset?.type === 'IMAGE'"
          [src]="c.asset | assetPreview:'large':'webp'"
          [alt]="c.title"
          class="w-full object-cover {{ getShapeClasses() }} {{ roundedClass}}"
        />
        <vsf-vimeo-player *ngIf="c.asset?.type === 'VIDEO' && c.asset?.mimeType === 'video/vimeo'"
          [source]="c.asset?.customFields?.videoUrl || c.asset?.source"
          [previewImageUrl]="c.asset?.imageUrl || c.asset?.preview"
          [previewAltText]="c.asset?.customFields?.altText ? c.asset?.customFields?.altText : 'Marketing Banner Video'">
        </vsf-vimeo-player>
        <h3 class="mt-4 text-lg" [innerHTML]="c.title | safeHtml"></h3>
        <span class="text-base mt-1" [innerHTML]="c.text | safeHtml"></span>
      </li>
    </ul>
  </ng-container>
  <!-- ===== Mobile Swiper slides ===== -->
  <ng-container *ngIf="isMobile && banner.mobileStyle === 'slide'">
    <swiper-container
        #swiper
        [slidesPerView]="1"
        pagination.type="bullets"
        pagination-clickable="true"
        centered-slides="true"
        lazy="true"
        effect="fade"
        [fadeEffect]="{ crossFade: true }"
        rewind="true"
        class="flex-glow object-cover custom-pagination under-container-pagination">
        <swiper-slide *ngFor="let c of banner.basicCards; trackBy: trackByIdx">
          <div class="px-3 flex flex-col">
              <img *ngIf="c.asset?.type === 'IMAGE'"
                [src]="c.asset | assetPreview:'large':'webp'"
                [alt]="c.title"
                class="w-full object-cover {{ getShapeClasses() }} {{ roundedClass}}"
              />
              <vsf-vimeo-player *ngIf="c.asset?.type === 'VIDEO' && c.asset?.mimeType === 'video/vimeo'"
                [source]="c.asset?.customFields?.videoUrl || c.asset?.source"
                [previewImageUrl]="c.asset?.imageUrl || c.asset?.preview"
                [previewAltText]="c.asset?.customFields?.altText ? c.asset?.customFields?.altText : 'Marketing Banner Video'">
              </vsf-vimeo-player>
              <h3 class="mt-4 text-lg" [innerHTML]="c.title | safeHtml"></h3>
              <span class="text-base mt-1" [innerHTML]="c.text | safeHtml"></span>
          </div>
        </swiper-slide>
    </swiper-container>
  </ng-container>
  <button *ngIf="!isMobile && startIndex > 0"
      (click)="showPreviousItems()"
      class="absolute top-1/2 -translate-y-1/2 left-[-20px] bg-gray-100/90
            text-gray-500 rounded-full w-10 h-10 flex items-center
            justify-center shadow opacity-40 hover:bg-white">
    <fa-icon icon="chevron-left"></fa-icon>
  </button>

  <button *ngIf="!isMobile && startIndex + itemsPerSlide < itemsCount"
      (click)="showNextItems()"
      class="absolute top-1/2 -translate-y-1/2 right-[-20px] bg-gray-100/90
            text-gray-500 rounded-full w-10 h-10 flex items-center
            justify-center shadow opacity-40 hover:bg-white">
    <fa-icon icon="chevron-right"></fa-icon>
  </button>
  </div>
</div>
